// 首先引入Mock
const Mock = require('mockjs');

// 设置拦截ajax请求的相应时间
Mock.setup({
    timeout: '200-600'
});

let configArray = [];

// 使用webpack的require.context()遍历所有mock文件
const files = require.context('.', true, /\.js$/);
files.keys().forEach((key) => {
    if (key === './index.js') return;
    configArray = configArray.concat(files(key).default);
});

// 注册所有的mock服务
configArray.forEach((item) => {
    for (let [path, target] of Object.entries(item)) {
        let protocol = path.split('|');
        Mock.mock(new RegExp('^' + protocol[1]), protocol[0], target);
    }
});
var arr = []
arr = Mock.mock({
  'list|22-100': [ // 生成一个 length是 22~100之间的数组
    { 'inspectionId': '@integer(3,1000000)', // 生成1-1000000之间的巡视工单id
      'eleContractNo': '@string(3,50)', // 生成3-50位的产品合同号-梯号
      'mntContractNo': '@string(3,50)', // 生成3-50位的保养合同号
      'customerName': '@cname', // 生成客户名称
      'onsiteEleName': '@string(3,50)', // 生成3-50位的现场客户梯号
      'inspectionType|1': ['ELEVATOR', 'ESCALATOR'], // 生成作业类型
      'userName': '@cname', // 生成保养巡视人员
      'inspectionDate': '@date(yyyy-MM-dd)', // 生成巡视时间
      'h|1': '@time(HH:mm)-@time(HH:mm)', // 生成巡视时间段
      'orderCode|1': ['INITIATED', 'CHANGE_REQUEST', 'INSPECTION_AUDIT', 'COMPLETE'] // 生成订单状态
    }
  ],
  'code': '2000',
  'message': '这是mock数据'
})
// Mock.mock(RegExp('/inspection/work/order'), 'post',require('./userInfo.json'), () => {return arr})
Mock.mock('/api/addgoods', 'post',require('./userInfo.json'), function (option) {})
Mock.mock('/api/addgoods2', 'post',require('./userInfo2.json'), function (option) {})
Mock.mock('/api/addgoods3', 'post',require('./userInfo3.json'), function (option) {})
Mock.mock('/api/addgoods4', 'post',require('./userInfo4.json'), function (option) {})
// const list = []
// const length = 18
// for (let i = 0; i < length; i++) {
//     list.push(
//         Mock.mock({
//             id: '@id',
//             account: '@first',
//             name: '@name',
//             email: '@email',
//             mobile: '@phone',
//             sex: '@integer(0,1)',
//             type: "@integer(100,101)",
//             status: "@integer(0,1)",
//         })
//     )
    
// }
